import React from 'react';
import { Check } from 'react-feather';

interface WizardStepsProps {
  steps: string[];
  active: number;
  onSelect: (index: number) => void;
  label: string;
}

/**
 * Numbered step indicator for multi-step forms. src/ui has no stepper yet, so this lives
 * next to the Add Teacher wizard; promote it to src/ui if another wizard needs it.
 */
const WizardSteps: React.FC<WizardStepsProps> = ({ steps, active, onSelect, label }) => (
  <nav aria-label={label}>
    <ol className="wizard-steps">
      {steps.map((title, index) => {
        const state = index === active ? 'current' : index < active ? 'done' : 'todo';
        return (
          <li key={title} className={`wizard-steps__item wizard-steps__item--${state}`}>
            <button
              type="button"
              className="wizard-steps__button"
              aria-current={index === active ? 'step' : undefined}
              onClick={() => onSelect(index)}
            >
              <span className="wizard-steps__index" aria-hidden>
                {state === 'done' ? <Check size={14} /> : index + 1}
              </span>
              <span className="wizard-steps__title">{title}</span>
            </button>
          </li>
        );
      })}
    </ol>
  </nav>
);

export default WizardSteps;
